<template>
  <v-form ref="form" v-model="valid">
    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.title"
          placeholder="VD: Vệ sinh máy chiếu định kỳ, Tra keo tản nhiệt máy tính..."
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập tiêu đề']"
        >
          <template v-slot:label>
            Tên kế hoạch bảo dưỡng <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="formData.asset"
          :items="assetList"
          item-text="name"
          item-value="id"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng chọn thiết bị']"
        >
          <template v-slot:label>
            Thiết bị áp dụng <span class="red--text font-weight-bold">*</span>
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
          v-model="formData.frequency"
          :items="frequencyList"
          outlined
          dense
        >
          <template v-slot:label>
            Chu kỳ bảo dưỡng <span class="red--text font-weight-bold">*</span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.nextDueDate"
          type="date"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng chọn ngày đến hạn']"
        >
          <template v-slot:label>
            Ngày đến hạn tiếp theo <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.performer"
          label="Người / Đơn vị thực hiện"
          placeholder="VD: Kỹ thuật viên IT"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="formData.status"
          :items="statusList"
          outlined
          dense
        >
          <template v-slot:label>
            Trạng thái <span class="red--text font-weight-bold">*</span>
          </template>
        </v-select>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="formData.note"
          label="Nội dung công việc chi tiết"
          outlined
          dense
          rows="2"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { Asset } from '@/plugins/api'

export default {
  name: 'ScheduleForm',
  data() {
    return {
      valid: true,
      assetList: [],
      frequencyList: [
        { text: 'Hàng tháng', value: 'MONTHLY' },
        { text: 'Hàng quý (3 tháng)', value: 'QUARTERLY' },
        { text: 'Hàng năm', value: 'YEARLY' }
      ],
      statusList: [
        { text: 'Sắp tới', value: 'UPCOMING' },
        { text: 'Quá hạn', value: 'OVERDUE' },
        { text: 'Đã hoàn thành', value: 'COMPLETED' }
      ],
      formData: {
        title: '',
        asset: null,
        frequency: 'QUARTERLY',
        nextDueDate: new Date().toISOString().substring(0, 10),
        performer: '',
        status: 'UPCOMING',
        note: ''
      }
    }
  },
  async created() {
    try {
      const assets = await Asset.search({ _limit: -1, isDelete: false })
      this.assetList = assets || []
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return { ...this.formData }
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  }
}
</script>
